import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import { ICDDiagnose } from "app/_models/icd-diagnose.model";
import { environment } from "environments/environment";
import { CommonService } from "app/reusable/common.service";
import { MidOfficeDiagnose } from 'app/_models/mid-office-diagnose.model';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { CedConfirmDialogService } from "ced-ng-library";

@Component({
  selector: "app-icd-diagnoses-list",
  templateUrl: "./icd-diagnoses-list.component.html",
  styleUrls: ["./icd-diagnoses-list.component.scss"],
})
export class IcdDiagnosesListComponent implements OnInit, OnDestroy {
  gridData = [];
  public AddDialogOpened = false;
  public UpdateDialogOpened = false;
  public DeleteDialogOpened = false;
  public serverUrlSlot3 : string = environment.Services.AlphaURLSlot3;
  @Input() modId: string;
  @Output() icdDiagnosesChange = new EventEmitter();
  public list: any[] = [];
  AddData = [];
  EditData = [];
  inialList: any;
  selectedIcdDiagnoses= null;
  private _subject$: Subject<boolean> = new Subject();

  constructor(private cd: ChangeDetectorRef,
    private CommonService: CommonService,private cedConfirmService: CedConfirmDialogService) { }

  ngOnInit() {
    if (this.modId != undefined) {
      this.loadIcdDiagnoses();
    }
  }

  loadIcdDiagnoses(): void {
    let GetMidOfficeByIdUrl = `MidOfficeDiagnose/GetById/${this.modId}`;
    this.CommonService.getData(GetMidOfficeByIdUrl, this.serverUrlSlot3).pipe(takeUntil(this._subject$)).subscribe((data) => {
      this.inialList = data as MidOfficeDiagnose;
      this.gridData = this.inialList.icdDiagnoses;
      this.icdDiagnosesChange.emit(this.inialList.icdDiagnoses);
    });
  }

  deleteitem;
  edititem;
  public open(component, ToSend) {
    this[component + "Opened"] = true;
    this.edititem = ToSend;
    this.deleteitem = ToSend;
  }
  openDetails(component) { 
    if(this.selectedIcdDiagnoses != null)
    this.open(component,this.selectedIcdDiagnoses);
    this.selectedIcdDiagnoses = null; 
  }
 
  onCellClick($event) {
    this.selectedIcdDiagnoses = $event.dataItem
  }
  public Add(event) {
    this.AddDialogOpened = event.dialogstatus;
    if (event.icdDiagnose != "") {
      let icdDiagnose: ICDDiagnose;
      icdDiagnose = event.icdDiagnose;
      this.gridData.push(icdDiagnose);
    }
    this.icdDiagnosesChange.emit(this.gridData);
    this.gridData = [...this.gridData];
  }

  public Update(event) {
    this.UpdateDialogOpened = event.dialogstatus;
    if (event.icdDiagnose != "") {
      this.gridData = this.gridData.filter((e) => e != this.edititem);
      this.gridData.push(event.icdDiagnose);
    }
    this.icdDiagnosesChange.emit(this.gridData);
    this.gridData = [...this.gridData];
  }


  delete(event) {
    this.DeleteDialogOpened = event.dialogstatus;
    if (event.icdDiagnose !== null) {
      this.gridData = this.gridData.filter(e => e != event.icdDiagnose);
      this.icdDiagnosesChange.emit(this.gridData);
      this.gridData = [...this.gridData];
    }
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}